import { gql } from '@apollo/client';

const PRODUCT_REVIEWS = gql`
  query ProductReviews($input: ProductReviewsInput!) {
    productReviews(input: $input) {
      product {
        uuid
        name
        shortName
        slug
      }
      content {
        uuid
        slug
        parentUuid
        position
        name
        itemsReady
        itemsAvailable
      }
      itemsReady
      itemsAvailable
      greQuantItemsReady
      greVocabItemsReady
    }
  }
`;

export default PRODUCT_REVIEWS;
